import type { JSX } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";

import { ClientList } from "./ClientList";
import {
  type ClientListDataProps,
  clientListDataSchema,
} from "./ClientList.schema";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    "client-list": { props: ClientListDataProps; handle: undefined };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-client-list": HTMLElement;
  }
}

export function RWCClientList({ filter }: ClientListDataProps): JSX.Element {
  return <ClientList filter={filter} />;
}

componentManager.register(
  rwc("client-list", {
    component: RWCClientList,
    dataSchema: clientListDataSchema,
  }),
);
